import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.admin.document');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-institute-admin-document',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.admin.document/view.scss */
/* src/app/portal.institute.admin.document/view.scss: no such file or directory */`],
})
export class PortalInstituteAdminDocumentComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    @Input() insID: any;
    @Input() mode: any;

    public documents: any = [];

    public loaded: boolean = true;
    // 업로드 제약
    private readonly maxSize = 10 * 1024 * 1024; // 10MB
    private readonly allowedExt = [
        'pdf', 'hwp', 'hwpx', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt',
        'png', 'jpg', 'jpeg', 'gif', 'webp'
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 문서함 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { insID: this.insID });
        if (code != 200) return await this.service.alert.error("Error!");
        this.documents = data;
        await this.service.render();
    }

    public async download(doc: any) {
        let download = wiz.url('download?id=' + this.insID + "&title=" + doc.title)
        window.open(download, '_blank');
    }

    public async delete(info: any) {
        let res = await this.service.alert.error(`"${info.title}" 파일을 정말 삭제하시겠습니까?`);
        if (res) {
            const { code, data } = await wiz.call("delete", info);
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.success("파일 삭제 완료!");
            await this.load();
        }
    }

    public async upload() {
        let files = await this.service.file.select({ accept: '.pdf,.hwp,.hwpx,.doc,.docx,.xls,.xlsx,.ppt,.pptx', multiple: true });

        this.loaded = false;
        await this.service.render();

        let fd = new FormData();
        let fileSizes = [];

        for (let i = 0; i < files.length; i++) {
            let file = files[i]
            if (!file.filepath) file.filepath = file.name;
            fd.append('file[]', file);
            fileSizes.push(file.size)
        }
        fd.append("insID", this.insID);
        fd.append("filesize", JSON.stringify(fileSizes))

        let url = wiz.url('upload');
        const { code } = await this.service.file.upload(url, fd)
        if (code != 200) return await this.service.alert.error("Error!");
        else this.loaded = true;
        await this.service.render();

        await this.load();
    }

    public getFileIcon(type: string) {
        switch (type.toLowerCase()) {
            case 'pdf': return '📄';
            case 'docx':
            case 'doc': return '📝';
            case 'xlsx':
            case 'xls': return '📊';
            case 'pptx':
            case 'ppt': return '📋';
            case 'txt': return '📃';
            default: return '📁';
        }
    }
}

export default PortalInstituteAdminDocumentComponent;